import checkIcon from './ToastIcons/success.svg';
import cancelIcon from './ToastIcons/cancel.svg';
import errorIcon from './ToastIcons/error.svg';

export const TOAST_PROPERTIES = [
    {
      id: Math.floor((Math.random() * 101) + 1),
      title: 'Success',
      description: 'This is a success toast component',
      backgroundColor: '#161616',
      color: '#32A75A',
      icon: checkIcon,
      cancelIcon: cancelIcon
    },
    {
      id: Math.floor((Math.random() * 101) + 1),
      title: 'Error',
      description: 'This is a success toast component',
      backgroundColor: '#161616',
      color: '#EF4C49',
      icon: errorIcon,
      cancelIcon: cancelIcon
    }
  ];
  